/**
 * ANI Swap Modal Footer Component
 *
 * Displays the confirm button for ANI swaps in the confirmation modal.
 */

import { Trans } from '@lingui/macro'

import { ButtonError } from '../Button'
import { AutoColumn } from '../Column'

interface AniSwapModalFooterProps {
  onConfirm: () => void
}

export default function AniSwapModalFooter({ onConfirm }: AniSwapModalFooterProps) {
  return (
    <AutoColumn gap="sm" style={{ padding: '12px 16px' }}>
      <ButtonError onClick={onConfirm} id="confirm-swap-or-send">
        <Trans>Confirm Swap</Trans>
      </ButtonError>
    </AutoColumn>
  )
}
